import {lazy} from 'react';

export const KeyInformationLazy = lazy(() => import(/* webpackChunkName: "keyInformation" */ '.'));
